import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LanguageProvider } from './i18n/LanguageContext';

const { pathname, search, hash } = window.location;
if (pathname !== '/') {
  const normalizedPath = pathname.replace(/\/+$/, '') || '/';
  const nextHash = hash && hash !== '#' ? hash : `#${normalizedPath}`;
  window.history.replaceState(null, '', `/${search}${nextHash}`);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
